import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';

import { FREE_TRIAL_ENABLED, STORE_PAYMENT_MODAL_TYPE } from '../../../../const';
import bannerAvatars from '../../../../resources/images/subscription/bannerAvatars.png';
import { getUserPlan } from '../../../../store/slices/authSlice';
import { getPaymentModalType, setShowPaymentModal } from '../../../../store/slices/modalsSlice';
import { getFeaturedSubscriptionPlan, getTrialPlan } from '../../../../store/slices/paymentsSlice';
import PaymentButton, { paymentBtnType } from '../../../common/PaymentButton';
import styles from './offer.module.scss';

const OfferPaymentContent = () => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const plan = useSelector(getFeaturedSubscriptionPlan);
    const userPlan = useSelector(getUserPlan);
    // Defensive: with the trial off no new offers are created, but an account
    // granted one earlier still reaches this modal — and its CTA must not start
    // a trial. See FREE_TRIAL_ENABLED.
    const paymentButtonType = userPlan.isTrial || !FREE_TRIAL_ENABLED ? paymentBtnType.subscription : paymentBtnType.trial;
    const trialPlan = useSelector(getTrialPlan);
    const planPrice = plan?.price;
    const planBasePrice = plan?.basePrice;
    const price = planPrice ? planPrice?.currency?.symbol + planPrice?.value : '';
    const basePrice = planBasePrice ? planBasePrice?.currency?.symbol + planBasePrice?.value : '';
    const modalType = useSelector(getPaymentModalType);

    let modalData = {};
    switch (modalType) {
        case STORE_PAYMENT_MODAL_TYPE.trial:
            modalData = {
                title: {
                    key: 'pages.payment.title1Offer'
                },
                label: {
                    key: 'pages.payment.label1Offer',
                    values: { price, trialDays: trialPlan?.period?.days }
                },
                button: {
                    key: 'buttons.freeTrial_offer'
                },
                header: {
                    key: 'pages.payment.offerLabelTrial'
                }
            };
            break;
        case STORE_PAYMENT_MODAL_TYPE.subscription:
            modalData = {
                title: {
                    key: 'pages.payment.titleOffer'
                },
                label: {
                    key: 'pages.payment.labelOffer'
                },
                button: {
                    key: 'buttons.offer'
                },
                header: {
                    key: 'pages.payment.offerLabel'
                }
            };
            break;
        default:
            break;
    }

    const onCloseBtn = () => {
        dispatch(setShowPaymentModal(false));
    };

    return (
        <>
            <div className={styles.banner}>
                <div className={styles.head}>
                    <h2 className={styles.special}>{t('pages.payment.offerTitle')}</h2>
                    <div className={styles.icons}>
                        <img src={bannerAvatars} alt={t('pages.payment.bannerAlt')} />
                    </div>
                </div>
                <div className={styles.column}>
                    <p className={styles.description}>{t(modalData.header.key, modalData.header.values)}</p>
                    <PaymentButton text={t('buttons.getOffer')} type={paymentButtonType} extraClasses={[styles.cta]} />
                </div>
                <div className={styles.discount}>
                    <div className={styles.basePrice}>{basePrice}</div>
                    <div className={styles.price}>{price}</div>
                </div>
            </div>
            <div className={styles.wrapper}>
                <h2 className={styles.title}>{t(modalData.title.key, modalData.title.values)}</h2>
                <p className={styles.text}>{t(modalData.label.key, modalData.label.values)}</p>
                <div className={styles.buttons}>
                    <button onClick={onCloseBtn} className={styles.cancel}>
                        {t('buttons.noThanks')}
                    </button>
                    <PaymentButton
                        text={t(modalData.button.key, modalData.button.values)}
                        type={paymentButtonType}
                        googleEvent={'chatPopup'}
                        extraClasses={[styles.btn]}
                    />
                </div>
            </div>
        </>
    );
};

export default OfferPaymentContent;
